import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { u6enterprise } from './products/u6enterprise.mjs';
import { u6lr } from './products/u6lr.mjs';
import { u6plus } from './products/u6plus.mjs';
import { u6pro } from './products/u6pro.mjs';
import { u7lite } from './products/u7Lite.mjs';
import { u7lr } from './products/u7lr.mjs';
import { u7pro } from './products/u7pro.mjs';
import { u7proMax } from './products/u7proMax.mjs';
import { u7proXg } from './products/u7proXg.mjs';
import { u7proXgs } from './products/u7proXgs.mjs';
import './properties/index.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { wifiTechnology } from './properties/wifiTechnology.mjs';
import { dedicatedSpectral } from './properties/dedicatedSpectral.mjs';
import { radio6Ghz } from './properties/radio6Ghz.mjs';
import { wifiCoverage } from './properties/coverage.mjs';
import { connectedDevices } from './properties/connectedDevices.mjs';
import { powerMethodPoe } from './properties/powerMethodPoe.mjs';
import { uplink } from './properties/uplink.mjs';
import { wifiMounting } from './properties/wifiMounting.mjs';
"use strict";
const WifiFlagship = {
  properties: [dimensions, wifiTechnology, dedicatedSpectral, radio6Ghz, wifiCoverage, connectedDevices, powerMethodPoe, uplink, wifiMounting],
  products: [u7proXgs, u7proXg, u7proMax, u7pro, u7lr, u7lite, u6enterprise, u6pro, u6lr, u6plus],
  columnWidth: TABLE_COLUMN_WIDTH,
  showBadges: true
};
export { WifiFlagship };
//# sourceMappingURL=WifiFlagship.mjs.map
